import { useEffect } from "react"
import { useDispatch } from "react-redux"
import { styled, Theme } from "@mui/material/styles"
import Snackbar from "@mui/material/Snackbar"
import Alert from "@mui/material/Alert"
import AlertTitle from "@mui/material/AlertTitle"
import Grow from "@mui/material/Grow"
import { Severity } from "types/general.types"
import { updateGlobalToastMessage } from "appRedux/slices/globalSlice"
import SuccessIcon from "components/atoms/_icons/SuccessIcon"
import WarningIcon from "components/atoms/_icons/WarningIcon"
import ErrorIcon from "components/atoms/_icons/ErrorIcon"
import InfoIcon from "components/atoms/_icons/InfoIcon"

const AUTO_HIDE_DURATION = 3000

type ToastProps = {
  open: boolean;
  message: string;
  title?: string;
  severity: Severity;
}

export default function Toast(props: ToastProps) {
  const { open, message, title, severity } = props

  const dispatch = useDispatch()

  useEffect(() => {
    setTimeout(() => {
      dispatch(updateGlobalToastMessage(null))
    }, AUTO_HIDE_DURATION)
  }, [])

  return <StyledSnackbar
    open={open}
    autoHideDuration={AUTO_HIDE_DURATION}
    severity={severity}
    TransitionComponent={Grow}
  >
    <Alert
      severity={severity}
      variant="filled"
      iconMapping={{
        success: <SuccessIcon/>,
        warning: <WarningIcon/>,
        error: <ErrorIcon/>,
        info: <InfoIcon/>
      }}
    >
      {title && <AlertTitle>{title}</AlertTitle>}
      {message}
    </Alert>
  </StyledSnackbar>
}

type StyledSnackbarProps = {
  theme?: Theme;
  severity: Severity;
}

const StyledSnackbar = styled(Snackbar)(({ theme, severity }: StyledSnackbarProps) => ({
  bottom: "28px",

  "& .MuiAlert-root": {
    width: "100%",
    borderRadius: "8px",
    fontSize: "1.2rem",
    fontWeight: 400,
    backgroundColor: theme?.palette[severity]["4"],
    color: theme?.palette.gray["14"],
    alignItems: "center",

    "&:after": {
      content: "''",
      width: "99%",
      height: "100%",
      position: "absolute",
      top: 0,
      right: 0,
      backgroundColor: theme?.palette[severity]["1"],
      borderRadius: "8px"
    },

    "& .MuiAlert-icon": {
      zIndex: 1
    },

    "& .MuiAlert-message": {
      zIndex: 1,
      fontFamily: "VazirmatnFD, serif !important",

      "& .MuiAlertTitle-root": {
        color: theme?.palette[severity]["4"],
        fontWeight: 500,
        fontSize: "1.2rem"
      }
    }
  }
}))
